module.exports = __webpack_public_path__ + "img/5959b2a1a7f617e1b175c19e8c9f12c4.jpg";